<template>
   <el-tabs type="border-card">
        <el-tab-pane label="品牌编辑">
            <div style="margin-top:16px;" >
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="中文名称">
                        <el-input v-model.trim="form.cnName" placeholder="中文名称"></el-input>
                    </el-form-item>
                    <el-form-item label="英文名称">
                        <el-input v-model.trim="form.enName" placeholder="英文名称"></el-input>
                    </el-form-item>
                    <el-form-item label="简称">
                        <el-input v-model.trim="form.abbreviation" placeholder="简称"></el-input>
                    </el-form-item>
                    <el-form-item label="网址">
                        <el-input v-model.trim="form.supplierLink" placeholder="网址"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="onSubmit">立即编辑</el-button>
                        <el-button size="mini" @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
  export default {
    data() {
      return {
        form: {
          id: '',
          cnName: '',
          enName: '',
          abbreviation:'',
          supplierLink:'',
          token: this.user.getToken()
        },
      }
    },
    methods: {
      onSubmit() {
        // 初始化默认加载菜单
        this.http.post(
          '/brand/editor',
          this.form, res => {
            if (res.success) {
              // 返回正确的处理
              this.$router.push("/brand/list")
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      },
      onCancel() {
          this.$router.go(-1)
      }
    },
    mounted() {
      this.form = this.$route.params
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/brand/BrandEditor.vue